import React from 'react';
import { ReactComponent as IconLoading } from '../../assets/icons/spinner.svg';
export default function Loader({ }){
    return <div className="loader">
                <IconLoading className="icon icon-loading"/>
        </div>
}